var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolBidirectional = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M22.229 2.164c.448 0 .896.171 1.237.513l1.82 1.817a1.747 1.747 0 0 1 .112 2.352L6.596 25.657c-.37.37-.854.555-1.338.555s-.97-.185-1.339-.554L2.304 24.04a1.89 1.89 0 0 1-.554-1.339c0-.484.185-.968.554-1.338L20.992 2.677c.341-.342.79-.513 1.237-.513"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.645 21.414 1.571 1.563M9.069 18.99l1.574 1.56M11.493 16.566l1.572 1.561M13.917 14.142l1.575 1.559M16.341 11.717l1.566 1.57M18.635 9.423l1.565 1.571M21.059 6.999l1.566 1.57"
})), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M12.373 8.404 8.589 4.621a1 1 0 0 0-1.414 0L5.407 6.389a1 1 0 0 0 0 1.414l3.784 3.783M16.5 18.882l3.783 3.784a1 1 0 0 0 1.415 0l1.767-1.768a1 1 0 0 0 0-1.414L19.682 15.7"
})))));
export { SvgToolBidirectional as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-bidirectional.svg";